module.exports = __webpack_public_path__ + "assets/img/ptp04.41ec74d4.png";